<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 種別
        span.validation-label 必須
      .right-side
        slot(name="question")

    .register-value.sendmessage-type-radios
      label.register-radio-label
        input#type-0.register-radio-form(
          v-model="_value"
          name="sendmessage-type"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="種別")
        span.register-radio-text 家族
      label.register-radio-label(v-show="2 <= planType")
        input#type-1.register-radio-form(v-model="_value" name="sendmessage-type" type="radio" :value="1")
        span.register-radio-text 施設関係者

    .error-messages(v-for="error in errors.collect('sendmessage-type')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { PlanType } from "@/commons/services/Plans";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputSendMessageGroupType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: number;

  @Prop({ required: true, type: Number })
  planType!: PlanType;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.sendmessage-type-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}
</style>
